import React from 'react';

export default ( { className, fill, ...props } ) => (
    <svg width="24" height="24" className={ className } { ...props } viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16 12L9.43 19L8 17.62L13.28 12L8 6.38L9.43 5L16 12Z" fill={ fill || 'currentColor' } />
    </svg>
);
